module.exports = __webpack_public_path__ + "img/7.ce4da400.jpg";